import { Color3, Color4 } from '@babylonjs/core/Maths/math.color';
import type { IVector3, IVector4 } from '@seddi/math-v2';

/**
 * Create color3.
 * @param v - Value.
 */
export const createColor3 = (v: IVector3): Color3 => {
  return new Color3(v.x, v.y, v.z);
};

/**
 * Create color4.
 * @param v - Value.
 */
export const createColor4 = (v: IVector4): Color4 => {
  return new Color4(v.x, v.y, v.z, v.w);
};
